import {createFileRoute, redirect} from '@tanstack/react-router'

import getReferraId from '@/lib/referral/getReferralId'
import setReferraId from '@/lib/referral/setReferralId'
import {SignUpRoute} from '@/routeRegistry'
import Referral from '@/views/Referral'

export const Route = createFileRoute('/r/$referralId')({
  beforeLoad: ({params}) => {
    // NOTE: only set referralId if it doesn't exist yet
    const currentReferralId = getReferraId()
    if (!currentReferralId) setReferraId(params.referralId)
    throw redirect({
      to: SignUpRoute.fullPath,
    })
  },
  component: Referral,
})
